import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import CenterPanel from './centerPanel';
import ScrollToTopButton from '../../../shared/scrollToTopBtn/content';
import {
  updateMeetingRoomSearch,
  updateSelectedParticipantInMRForm,
  resetMRSearchForm,
  updateIsOnMRListingPage,
} from '../../../../actions/meetingRoom';
import { updateSearchColumn } from '../../../../actions/shared';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import PageHeader from '../../header';
import ParticipantModal from '../pariticipant/content';
import ResetGuestLinkModal from '../reset-guest-link/content';
import EditPropertiesModal from 'containers/EditMeetingRoomProperties.js';
import DeleteMeetingRoomModal from '../delete/content.js';
import { previousPage } from 'actions/navigationBar';
import { updateFilterValue } from 'actions/organisation';

export const MRsPageContext = React.createContext([{}, () => {}]);
const MRsPageContextProvider = (props) => {
  const [searchTermSubmitted, setSearchTermSubmitted] = useState('');
  return (
    <MRsPageContext.Provider value={[searchTermSubmitted, setSearchTermSubmitted]}>
      {props.children}
    </MRsPageContext.Provider>
  );
};

export default function ViewAllMeetingRooms(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateIsOnMRListingPage(true));
    // Clear meeting rooms in Redux State
    dispatch(resetMRSearchForm());
    dispatch(previousPage(window.APP.LANGUAGE.ViewMeetingRoom.Title));
    // Reset to default filter
    dispatch(updateFilterValue(1));
    return () => {
      dispatch(
        updateSelectedParticipantInMRForm({
          selectedParticipant: {},
          isUserInThisCall: false,
        })
      );
      dispatch(updateMeetingRoomSearch(''));
      dispatch(updateSearchColumn(null));
      dispatch(updateIsOnMRListingPage(false));
      dispatch(resetMRSearchForm());
    };
  }, []);

  let bottomSession = <AccordionSession userId={props.userId} />;

  const renderModal = () => {
    if (
      props.selectedMeetingRoom &&
      props.selectedMeetingRoom.permissions &&
      props.selectedMeetingRoom.permissions.length > 0
    ) {
      let hasEditMRAccess = props.selectedMeetingRoom.permissions.indexOf('EDIT') > -1;
      let hasViewMRAccess = props.selectedMeetingRoom.permissions.indexOf('VIEW') > -1;
      let hasDeleteMRAccess = props.selectedMeetingRoom.permissions.indexOf('DELETE') > -1;
      return (
        <div>
          {props.showEditMeetingRoomModal && hasEditMRAccess ? (
            <EditPropertiesModal meetingRoomForm={props.meetingRoomForm} dispatch={props.dispatch} />
          ) : (
            ''
          )}
          {props.showDeleteMeetingRoomModal && hasDeleteMRAccess ? (
            <DeleteMeetingRoomModal meetingRoomForm={props.meetingRoomForm} />
          ) : (
            ''
          )}
        </div>
      );
    } else return '';
  };

  return (
    <MRsPageContextProvider>
      <div className="main-ui-container meeting-room-view-all new-waiting-area-view-one">
        <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
          <div className="left-hand-side-panel">
            <div className="relative mrrm">
              <PageHeader
                title={APP.LANGUAGE.ViewMeetingRoom.Title}
                titleColor="font-color-secondary"
                notRenderLogo={true}
              >
                <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.MeetingRoomIcon.default} />
              </PageHeader>
            </div>
            <div className="view-all-meeting-room-container pdlm pdrm">
              <CenterPanel
                showViewMeetingRoomParticipantModal={props.showViewMeetingRoomParticipantModal}
                currentMeetingRoomCall={props.currentMeetingRoomCall}
                updateSearchColumn={props.updateSearchColumn}
                meetingRooms={props.meetingRooms}
                mrSearchForm={props.mrSearchForm}
                showCopyLinkToClipboardModalInMR={props.showCopyLinkToClipboardModalInMR}
                meetingRoomForm={props.meetingRoomForm}
                selectedMeetingRoom={props.selectedMeetingRoom}
                isInCall={props.isInCall}
              />
            </div>
          </div>
          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel mrSearchForm={props.mrSearchForm} bottomSession={bottomSession} />
          </div>
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <div className="left-hand-side-panel-mobile">
            <PageHeader
              title={APP.LANGUAGE.ViewMeetingRoom.Title}
              titleColor="font-color-secondary"
              notRenderLogo={true}
            >
              <span>
                <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.MeetingRoomIcon.default} />
              </span>
            </PageHeader>
            {!!props.mrSearchForm.numberOfMRs ? (
              !!props.mrSearchForm.totalRowsForSet ? (
                <div className="pdbm pdrm pdlxs mrlxs bold" style={{ marginTop: '-15px' }}>
                  {APP.LANGUAGE.ViewMeetingRoom.NumberOfMRs}
                  {props.mrSearchForm.totalRowsForSet +
                    APP.LANGUAGE.ViewMeetingRoom.TotalNumberOf +
                    props.mrSearchForm.numberOfMRs}
                </div>
              ) : (
                <div className="pdbm pdrm pdlxs mrlxs bold" style={{ marginTop: '-15px' }}>
                  {APP.LANGUAGE.ViewMeetingRoom.NumberOfUsers}
                  {APP.LANGUAGE.ViewMeetingRoom.ZeroNumberOf + props.mrSearchForm.numberOfMRs}
                </div>
              )
            ) : (
              ''
            )}
            <div className="right-hand-side-panel-mobile">
              <RightPanelOrTopPanel mrSearchForm={props.mrSearchForm} bottomSession={bottomSession} />
            </div>
            <div>
              <CenterPanel
                showViewMeetingRoomParticipantModal={props.showViewMeetingRoomParticipantModal}
                currentMeetingRoomCall={props.currentMeetingRoomCall}
                updateSearchColumn={props.updateSearchColumn}
                meetingRooms={props.meetingRooms}
                mrSearchForm={props.mrSearchForm}
                showCopyLinkToClipboardModalInMR={props.showCopyLinkToClipboardModalInMR}
                meetingRoomForm={props.meetingRoomForm}
                selectedMeetingRoom={props.selectedMeetingRoom}
                isInCall={props.isInCall}
                isOnMobileOrTablet={true}
              />
            </div>
            <div className="mrtl right-hand-side-bottom-on-mobile">
              {bottomSession}
              <BottomLogo />
            </div>
          </div>
        </Container>

        <ParticipantModal
          showViewMeetingRoomParticipantModal={props.showViewMeetingRoomParticipantModal}
          participantFormData={props.selectedParticipantForm.selectedParticipant}
        />
        {props.showMeetingRoomResetGuestLink ? (
          <ResetGuestLinkModal selectedMeetingRoom={props.selectedMeetingRoom} />
        ) : (
          ''
        )}
        {renderModal()}
        <Container fluid as={Media} lessThan="computer">
          <ScrollToTopButton className="scroll-top-btn-desktop" />
        </Container>
      </div>
    </MRsPageContextProvider>
  );
}
